export const radioFontOptions = [
  {
    value: 'Righteous',
    label: 'Righteous',
    withFontStyle: true
  },
  {
    value: 'Merriweather',
    label: 'Merriweather',
    withFontStyle: true
  },
  {
    value: 'PT Serif',
    label: 'PT Serif',
    withFontStyle: true
  },
  {
    value: 'Chivo',
    label: 'Chivo',
    withFontStyle: true
  },
  {
    value: 'Inter',
    label: 'Inter',
    withFontStyle: true
  },
  {
    value: 'Roboto',
    label: 'Roboto',
    withFontStyle: true
  },
  {
    value: 'Tahoma',
    label: 'Tahoma',
    withFontStyle: true
  },
  {
    value: 'Montserrat',
    label: 'Montserrat',
    withFontStyle: true
  }
]
